module.exports = __webpack_public_path__ + "8920a75f042edf4ebf3e3e2265a7e842.jpg";